"use strict";

exports.__esModule = true;
exports.getCookie = getCookie;
exports.isObject = isObject;
exports.isUndefined = isUndefined;

function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

function isUndefined(value) {
  return value === undefined;
}

function getCookie(cname) {
  // avoid ssr error
  if (typeof window === undefined || typeof document === undefined) {
    return '';
  }

  var name = cname + '=';
  var cookieArr = document.cookie.split(';');

  for (var i = 0; i < cookieArr.length; i++) {
    var cookieStr = cookieArr[i];
    if (cookieStr.indexOf(name) != -1) return cookieStr.substring(name.length + 1, cookieStr.length);
  }

  return '';
}